import { TranslationMessages } from "react-admin";
import englishMessages from "ra-language-english";

const customEnglishMessages = {
    ...englishMessages,
    pos: {
        edit: "Edit"
    }
};

export default customEnglishMessages;
